module.exports = __WEBPACK_EXTERNAL_createRequire(import.meta.url)("async_hooks");